import styled, { keyframes, css } from 'styled-components'

const dotPulse = keyframes`
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.5);
  }
  50%, 100% {
    transform: scale(1);
  }
`

export const DotsWrapper = styled.div<{
  size: number
  durationSeconds: number
}>`
  display: flex;
  gap: ${({ size }) => size / 1.5}px;

  > div {
    width: ${({ size }) => size}px;
    height: ${({ size }) => size}px;
    border-radius: 50%;
    background-color: #000;
    animation: ${({ durationSeconds }) => css`
      ${dotPulse} ${durationSeconds}s infinite linear
    `};

    &:nth-of-type(2) {
      animation-delay: ${({ durationSeconds }) => durationSeconds / 5}s;
    }

    &:nth-of-type(3) {
      animation-delay: ${({ durationSeconds }) => (durationSeconds / 5) * 2}s;
    }
  }
`
